import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGroupTypesList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/group-types', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchGroupTypesForSelect(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/group-types-for-select', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
